module.exports = __webpack_public_path__ + "static/media/J-alert.0a78f413.svg";